import { ContentRepository } from '../internal/repositories/ContentRepository';
import { LoadContentUseCase } from '../internal/use-cases/LoadContentUseCase';

export class ServiceBusController {
    private contentRepository: ContentRepository;

    constructor(contentRepository: ContentRepository) {
        this.contentRepository = contentRepository;
    }

    public getServices = async ({ nodeId }: { nodeId: number }) => {
        await new LoadContentUseCase(nodeId).execute();
        const templates = this.contentRepository.nodes.get(nodeId);

        return templates ? templates.data : [];
    };
}
